import styled from '@emotion/styled';
import { Link, Typography, TypographyProps } from '@mui/material';
import React from 'react';
import { WsColors } from 'wisestep-base';

interface ExpandableLinkProps {
  url: string;
  label: string;
  variant?: 'body1' | 'body2' | 'caption';
}
export const StyledCollapsedTypography = styled(Typography)<TypographyProps>(() => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '100%',
  display: 'block',
}));

const CompressedLink: React.FC<ExpandableLinkProps> = ({ url, label, variant = 'body1' }) => (
  <StyledCollapsedTypography variant={variant}>
    <Link
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      underline="hover"
      color={WsColors.TheBlues750}
    >
      {label}
    </Link>
  </StyledCollapsedTypography>
);

export default CompressedLink;
